


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const addDocumentREd = function(state = initialState, action) {
switch (action.type) {
case Actions.ADD_ADDITIONAL_CASE_DOC:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.ADD_ADDITIONAL_CASE_DOC_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.ADD_ADDITIONAL_CASE_DOC_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
